<template>
  <va-dropdown
    class="locality-dropdown"
    offset="0, 16px"
    fixed
  >
    <div slot="anchor">
      <span icon="fa fa-save" class="userLogin"> {{ currentLocality.name }} </span>
      <va-icon slot="anchor" name="iconicstroke iconicstroke-home" class="userLogin ml-1"/>
    </div>

    <div class="locality-dropdown__content pl-4 pr-4 pt-2 pb-2">
      <div class="locality-dropdown__item row align--center pt-1 pb-1 mt-2 mb-2"
        v-for="(locality, id) in localities"
        :key="id"
        :class="{ active: locality === currentLocality }"
        @click="setLocality(locality)"
      >
        <span class="dropdown-item__text"> {{ locality.name }} </span>
      </div>
    </div>
  </va-dropdown>
</template>

<script>
import Vue from 'vue'
import { showError } from '@/global'
import { mapState } from "vuex";

export default {
  data () {
    return {
      localities: [],
    }
  },

  computed: {
    ...mapState(["currentUser", "currentLocality"]),
  },

  mounted() {
    this.localities = this.currentUser.localities
  },

  methods: {
    setLocality(locality) {
      this.$store.commit('updateLocality', locality)
    },
  },
}
</script>

<style lang="scss">
.locality-dropdown {
  cursor: pointer;
  margin-top: 0.3rem;

  &__content {
    overflow: scroll;
    max-height: 500px;
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: .5rem;
    width: 12rem;
    .flag-icon-small {
      min-width: 1.5rem;
      min-height: 1.5rem;
      margin-right: .5rem;
    }
  }
  &__item {
    padding-bottom: 0.625rem;
    cursor: pointer;
    flex-wrap: nowrap;
    &:last-of-type {
      padding-bottom: 0 !important;
    }
    &:hover, &.active {
      color: $vue-green;
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
